import React from 'react';
import styled from 'astroturf/react';

export const CountBubble = styled.div`
  box-sizing: content-box;
  border-radius: 50%;
  background: #bb0202;
  color: white;
  border: 1.62px solid #ffffff;
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  width: 18px;
  height: 18px;
  line-height: 18px;
`;

const DoubleDigitCountBubble = ({
  count,
  className,
}: {
  count: number | null;
  className?: string;
}) => {
  if (!count || count === 0) return null;

  const displayCount = count < 100 ? count : '99+';
  return <CountBubble className={className}>{displayCount}</CountBubble>;
};

export default DoubleDigitCountBubble;
